[
  {
    "id": "GET-B6P-L102-001",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Welk getal ligt precies tussen 1.200 en 1.300?",
    "options": ["1.250", "1.225", "1.275", "1.205"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "getallenlijn",
    "familyId": "GET-GETALLENLIJN",
    "explanation": "Het verschil is 100. De helft van 100 is 50. Dus 1.200 + 50 = 1.250.",
    "distractorExplanations": {
      "1": "Dit ligt op een kwart.",
      "2": "Dit ligt op driekwart.",
      "3": "Dit ligt heel dicht bij 1.200."
    }
  },
  {
    "id": "GET-B6P-L102-002",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Welke breuk is het grootst?",
    "options": ["$\\frac{1}{3}$", "$\\frac{1}{4}$", "$\\frac{1}{5}$", "$\\frac{1}{6}$"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_vergelijken",
    "familyId": "GET-BREUK-VGL",
    "explanation": "Hoe kleiner de noemer (onderkant), hoe groter het stuk. $\\frac{1}{3}$ is groter dan $\\frac{1}{4}$.",
    "distractorExplanations": {
      "1": "Een kwart is kleiner dan een derde.",
      "2": "Een vijfde is nog kleiner.",
      "3": "Een zesde is het kleinst van deze rij."
    }
  },
  {
    "id": "GET-B6P-L102-003",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Reken uit: 10.000 - 450 =",
    "options": ["9.550", "9.650", "9.450", "8.550"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-ZONDER",
    "explanation": "10.000 - 400 = 9.600. Dan nog 50 eraf: 9.600 - 50 = 9.550.",
    "distractorExplanations": {
      "1": "Je hebt er maar 350 afgehaald.",
      "2": "Je hebt er 550 afgehaald.",
      "3": "Je hebt een fout gemaakt bij de duizendtallen."
    }
  },
  {
    "id": "GET-B6P-L102-004",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Hoeveel is $\\frac{1}{5}$ deel van 100?",
    "options": ["20", "25", "50", "10"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_deel_van",
    "familyId": "GET-BREUK-DEEL",
    "explanation": "Je deelt 100 door 5. 100 : 5 = 20.",
    "distractorExplanations": {
      "1": "Dat is een kwart (1/4).",
      "2": "Dat is de helft (1/2).",
      "3": "Dat is een tiende (1/10)."
    }
  },
  {
    "id": "GET-B6P-L102-005",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Schrijf in cijfers: vijfenzeventigduizend driehonderd",
    "options": ["75.300", "57.300", "75.030", "7.530"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "getallen_schrijven",
    "familyId": "GET-GETAL-SCHRIJVEN",
    "explanation": "Vijfenzeventigduizend is 75.000. Driehonderd is 300. Samen 75.300.",
    "distractorExplanations": {
      "1": "Je hebt de 5 en 7 omgedraaid.",
      "2": "Dit is vijfenzeventigduizend dertig.",
      "3": "Dit is zeven-en-een-half duizend."
    }
  },
  {
    "id": "GET-B6P-L102-006",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Welk getal ligt precies tussen 500 en 600?",
    "options": ["550", "525", "575", "510"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "getallenlijn",
    "familyId": "GET-GETALLENLIJN",
    "explanation": "Het verschil is 100. De helft is 50. Dus 500 + 50 = 550.",
    "distractorExplanations": {
      "1": "Dit ligt op een kwart van het verschil.",
      "2": "Dit ligt op driekwart.",
      "3": "Dit ligt dicht bij 500."
    }
  },
  {
    "id": "GET-B6P-L102-007",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Welke breuk is kleiner: $\\frac{1}{2}$ of $\\frac{1}{3}$?",
    "options": ["$\\frac{1}{3}$", "$\\frac{1}{2}$", "Even groot", "Niet te zeggen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_vergelijken",
    "familyId": "GET-BREUK-VGL",
    "explanation": "Hoe groter de noemer, hoe kleiner de stukken. $\\frac{1}{3}$ is kleiner dan $\\frac{1}{2}$.",
    "distractorExplanations": {
      "1": "Een half is juist groter dan een derde.",
      "2": "Ze zijn niet even groot.",
      "3": "Je kunt het wel vergelijken."
    }
  },
  {
    "id": "GET-B6P-L102-008",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Reken uit: 5.000 - 1.200 =",
    "options": ["3.800", "3.200", "4.800", "2.800"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-ZONDER",
    "explanation": "5.000 - 1.000 = 4.000. Dan nog 200 eraf: 4.000 - 200 = 3.800.",
    "distractorExplanations": {
      "1": "Je hebt er maar 1.800 afgehaald.",
      "2": "Je hebt er maar 200 afgehaald.",
      "3": "Je hebt er 2.200 afgehaald."
    }
  },
  {
    "id": "GET-B6P-L102-009",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Hoeveel is $\\frac{1}{4}$ deel van 80?",
    "options": ["20", "40", "10", "30"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_deel_van",
    "familyId": "GET-BREUK-DEEL",
    "explanation": "Je deelt 80 door 4. 80 : 4 = 20.",
    "distractorExplanations": {
      "1": "Dat is de helft van 80.",
      "2": "Dat is een achtste van 80.",
      "3": "Dat is iets meer dan een kwart."
    }
  },
  {
    "id": "GET-B6P-L102-010",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Schrijf in cijfers: tweeëntwintigduizend vijfhonderd",
    "options": ["22.500", "22.050", "2.250", "20.250"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "getallen_schrijven",
    "familyId": "GET-GETAL-SCHRIJVEN",
    "explanation": "Tweeëntwintigduizend is 22.000. Vijfhonderd is 500. Samen 22.500.",
    "distractorExplanations": {
      "1": "Dit is tweeëntwintigduizend vijftig.",
      "2": "Dit is tweeduizend tweehonderdvijftig.",
      "3": "Dit is twintigduizend tweehonderdvijftig."
    }
  },
  {
    "id": "GET-B6P-L102-011",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Reken uit: 2.500 + 1.750 =",
    "options": ["4.250", "3.250", "4.750", "3.750"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-ZONDER",
    "explanation": "2.500 + 1.500 = 4.000. Dan nog 250 erbij: 4.000 + 250 = 4.250.",
    "distractorExplanations": {
      "1": "Je bent de 1.000 vergeten.",
      "2": "Je telde er 500 te veel bij op.",
      "3": "Je bent de 500 vergeten."
    }
  },
  {
    "id": "GET-B6P-L102-012",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Reken uit: 8.000 - 3.500 =",
    "options": ["4.500", "5.500", "3.500", "4.000"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-ZONDER",
    "explanation": "8.000 - 3.000 = 5.000. Dan nog 500 eraf: 5.000 - 500 = 4.500.",
    "distractorExplanations": {
      "1": "Je hebt er maar 2.500 afgehaald.",
      "2": "Dat is het getal dat je aftrekt.",
      "3": "Je bent de 500 vergeten af te trekken."
    }
  },
  {
    "id": "GET-B6P-L102-013",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Hoeveel is $\\frac{1}{3}$ deel van 60?",
    "options": ["20", "30", "15", "10"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_deel_van",
    "familyId": "GET-BREUK-DEEL",
    "explanation": "Je deelt 60 door 3. 60 : 3 = 20.",
    "distractorExplanations": {
      "1": "Dat is de helft van 60.",
      "2": "Dat is een kwart van 60.",
      "3": "Dat is een zesde van 60."
    }
  },
  {
    "id": "GET-B6P-L102-014",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Welk getal ligt het dichtst bij 3.000?",
    "options": ["2.980", "3.200", "2.500", "3.500"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "getallenlijn",
    "familyId": "GET-GETALLENLIJN",
    "explanation": "2.980 is maar 20 van 3.000 af. De andere getallen liggen verder weg.",
    "distractorExplanations": {
      "1": "3.200 is 200 van 3.000 af.",
      "2": "2.500 is 500 van 3.000 af.",
      "3": "3.500 is 500 van 3.000 af."
    }
  },
  {
    "id": "GET-B6P-L102-015",
    "module": "Getalbegrip",
    "difficulty": 102,
    "question": "Reken uit: 1.450 + 550 =",
    "options": ["2.000", "1.900", "2.100", "1.500"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-ZONDER",
    "explanation": "1.450 + 550 = 2.000. Want 450 + 550 = 1.000, en 1.000 + 1.000 = 2.000.",
    "distractorExplanations": {
      "1": "Je bent de 100 van 450+550 vergeten.",
      "2": "Je telde er 100 te veel bij op.",
      "3": "Je telde er maar 50 bij op."
    }
  }
]